const listItems = () => `
    padding: 8px 12px;
    cursor: pointer;
    font-weight: 400;
`;

export default listItems;
